import { render, staticRenderFns } from "./variation-tab-partial.vue?vue&type=template&id=17f69d9a"
import script from "./variation-tab-partial.vue?vue&type=script&lang=js"
export * from "./variation-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports